export default __webpack_public_path__ + "static/media/dayton-performing-arts-alliance-logo-web.cea2c680.svg";